import axios from "axios";
import { API_URI } from "../utils/config";

import { GET_ERRORS, GET_PROPERTY, GET_SINGLE_PROPERTY } from "./types";

// Get all Properties
export const getAllProperty = () => dispatch => {
  axios
    .get(
      `${API_URI}/properties?filter={"include":{"0": "user", "1": "property_type", "2": "currency_type"},"where": {"is_active	": 1},"skip": "0","limit":"all"}`
    )
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        dispatch({
          type: GET_PROPERTY,
          payload: data
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

// Get single Properties
export const getProperty = id => dispatch => {
  axios
    .get(
      `${API_URI}/properties/${id}?filter={"include":{"0": "user", "1": "property_type", "2": "currency_type", "3": "city", "4": "state", "5": "country", "6": "area_type", "7": "attachment"},"where": {"is_active	": 1},"skip": "0","limit":"all"}`
    )
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        const { data } = res.data;
        console.log(data);
        dispatch({
          type: GET_SINGLE_PROPERTY,
          payload: data
        });
      }
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err
      });
    });
};

// Update User
export const updateUser = (userData, id) => (dispatch, getState) => {
  let users = [...getState().auth.users];
  axios
    .put(`${API_URI}/users/${id}`, userData)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error.message
        });
      } else {
        const { data } = res.data;
        users = users.map(user => {
          if (user.id === data.id) {
            user = { ...user, ...data };
          }
          return user;
        });
        /*        dispatch({
          type: GET_USERS,
          payload: users
        }); */
      }
    })
    .catch(err => {
      if (err.response.data.error) {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data.error.message
        });
      }
    });
};

// Delete User
export const deleteUser = id => (dispatch, getState) => {
  let users = [...getState().auth.users];

  axios
    .delete(`${API_URI}/users/${id}`)
    .then(res => {
      if (res.data.error.code) {
        dispatch({
          type: GET_ERRORS,
          payload: res.data.error
        });
      } else {
        users = users.filter(user => user.id !== id);
        /*         dispatch({
          type: GET_USERS,
          payload: users
        }); */
      }
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};



// WEBPACK FOOTER //
// ./src/actions/propertyAction.js